import React, { useEffect, useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import {
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  Card,
  CardHeader,
  Divider,
  Backdrop,
  CircularProgress,
  IconButton,
  Alert,
  Snackbar,
} from "@mui/material";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axiosBaseURL from "../../../utilities/httpCommon";

/* global console */

export interface SetupDialogProps {
  id: string;
  keepMounted: boolean;
  value: any;
  open: boolean;
  onClose: (value?: any) => void;
}

const useStyles = makeStyles({
  root: {
    ".MuiDialogContent-root": {
      padding: "0px 0px 0px 0px !important",
      margin: 0,
    },
    "& .MuiDialog-paperWidthLg": {
      maxWidth: "none !important",
    },
    "& .MuiDialog-paper": {
      margin: 0,
    },
    "& .MuiDialogTitle-root": {
      padding: "1px !important",
      margin: 0,
    },
  },
  content: {
    "&:first-child": {
      padding: 0,
      margin: 0,
    },
  },
});

const emailRegex =
  /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|googlemail|yahoo|gmx|ymail|outlook|bluewin|protonmail|t-online|web\.|online\.|aol\.|live\.)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,15}|\d{1,3})(\]?)$/;

const SetupDialog = (props: SetupDialogProps) => {
  const { onClose, open, ...other } = props;
  const [checked, setChecked] = React.useState(false);
  const classes = useStyles();

  const defsetFormValues = {
    strorgname: "",
    strorgid: "",
    strenvname: "",
    strconname: "",
    strconemail: "",
    optaioption: false,
    strcountryname: "",
  };

  const [setupvalues, setsetupvalues] = useState(defsetFormValues);
  const [popupopen, setpopupopen] = React.useState(false);
  const [messagecaption, setmessagecaption] = useState("");
  const [loading, setLoading] = React.useState(false);

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleCancel = () => {
    onClose();
  };

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setpopupopen(false);
    onClose("OK");
  };

  useEffect(() => {
    if (open) {
      setsetupvalues(defsetFormValues);
      setChecked(false);
    }
  }, [open]);

  const handleOk = () => {
    console.log("Selected value: " + setupvalues);
    let formdata = {
      orgname: setupvalues.strorgname,
      orgid: setupvalues.strorgid,
      envname: setupvalues.strenvname,
      conname: setupvalues.strconname,
      conmail: setupvalues.strconemail,
      aienable: checked,
      countname: setupvalues.strcountryname,
      status: "Pending",
      startdate: new Date().toISOString(),
    };
    processsignupMessage(formdata);
  };

  const processsignupMessage = async (message: any) => {
    console.log("message");
    console.log(message);
    //setupenvironment
    setLoading(true);
    const res = await axiosBaseURL
      .post("/sfserver/setupenvironment", message, {
        withCredentials: true,
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          setpopupopen(true);
          setmessagecaption(error.response.data);
        } else if (error.request) {
          setpopupopen(true);
          setmessagecaption(error.request);
        } else {
          setpopupopen(true);
          setmessagecaption(error.message);
        }
      });
    setLoading(false);
    console.log(res);
    if (res && res.data) {
      setpopupopen(true);
      setmessagecaption(res.data.status);
    } else {
      setpopupopen(true);
      setmessagecaption("Error Occured");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setsetupvalues({
      ...setupvalues,
      [name]: value,
    });
  };

  return (
    <>
      <Dialog fullScreen open={open} {...other} className={classes.root}>
        <DialogContent dividers className={classes.content}>
          <Card sx={{ padding: 0.5, margin: 1 }} elevation={0}>
            <CardHeader
              sx={{ margin: 0, padding: 0, textAlign: "center" }}
              subheaderTypographyProps={{
                color: "#1C39BB",
                fontSize: 15,
                fontWeight: "bold",
                textAlign: "center",
              }}
              subheader="Setup Account"
            />
            <Divider />
            <Grid container>
              <Grid item xs={12} marginTop={2.5}>
                <FormControl fullWidth size="small" sx={{ marginTop: 0 }}>
                  <TextField
                    name="strorgname"
                    label="Organization Name"
                    size="small"
                    value={setupvalues.strorgname}
                    variant="outlined"
                    onChange={handleInputChange}
                    error={!setupvalues.strorgname}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginTop={2.5}>
                <FormControl fullWidth size="small" sx={{ marginTop: 0 }}>
                  <TextField
                    name="strorgid"
                    label="Organization ID"
                    size="small"
                    value={setupvalues.strorgid}
                    variant="outlined"
                    onChange={handleInputChange}
                    error={!setupvalues.strorgid}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginTop={2.5}>
                <FormControl fullWidth size="small" sx={{ marginTop: 0 }}>
                  <TextField
                    name="strenvname"
                    label="Environment Name"
                    size="small"
                    value={setupvalues.strenvname}
                    variant="outlined"
                    onChange={handleInputChange}
                    error={!setupvalues.strenvname}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginTop={2.5}>
                <FormControl fullWidth size="small" sx={{ marginTop: 0 }}>
                  <TextField
                    name="strconname"
                    label="Contact Name"
                    size="small"
                    value={setupvalues.strconname}
                    variant="outlined"
                    onChange={handleInputChange}
                    error={!setupvalues.strconname}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginTop={2.5}>
                <FormControl fullWidth size="small" sx={{ marginTop: 0 }}>
                  <TextField
                    name="strconemail"
                    label="Contact Work Email"
                    size="small"
                    value={setupvalues.strconemail}
                    variant="outlined"
                    onChange={handleInputChange}
                    error={!setupvalues.strconemail || !emailRegex.test(setupvalues.strconemail)}
                    helperText={
                      setupvalues.strconemail != null &&
                      setupvalues.strconemail.length > 0 &&
                      !emailRegex.test(setupvalues.strconemail)
                        ? "Please enter the work email"
                        : ""
                    }
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginTop={2.5}>
                <FormControl fullWidth size="small" sx={{ marginTop: 0 }}>
                  <TextField
                    name="strcountryname"
                    label="Country Name"
                    size="small"
                    value={setupvalues.strcountryname}
                    variant="outlined"
                    onChange={handleInputChange}
                    error={!setupvalues.strcountryname}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginTop={1.5} padding={0}>
                <FormControlLabel
                  control={<Checkbox checked={checked} onChange={handleCheckChange} />}
                  label="AI enabled"
                />
              </Grid>
            </Grid>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="small"
            onClick={handleOk}
            disabled={
              setupvalues.strorgname === "" ||
              setupvalues.strorgid === "" ||
              setupvalues.strenvname === "" ||
              setupvalues.strconname === "" ||
              setupvalues.strconemail === "" ||
              setupvalues.strcountryname === "" ||
              !emailRegex.test(setupvalues.strconemail)
            }
            sx={{ bgcolor: "#1C39BB", textTransform: "none" }}
          >
            <Typography sx={{ fontSize: 14 }}>Submit</Typography>
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={handleCancel}
            sx={{ bgcolor: "#1C39BB", textTransform: "none" }}
          >
            <Typography sx={{ fontSize: 14 }}>Cancel</Typography>
          </Button>
        </DialogActions>
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={popupopen} onClose={handleClose}>
          <Alert
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  handleClose();
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            severity="success"
            sx={{ width: "100%" }}
          >
            {messagecaption}
          </Alert>
        </Snackbar>
      </Dialog>
    </>
  );
};

export default SetupDialog;
